import { BASE_URL } from '../components/AppConfig';

const getAuthToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  return sessionToken ? `Bearer ${sessionToken}` : '';
};

const authFetch = async (path, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const response = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        ...(options.headers || {}),
      },
      ...options,
    });

    return response.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

const authMultipartFetch = async (path, formData, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const response = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        Authorization: token,
        ...(options.headers || {}),
      },
      ...options,
      body: formData,
    });

    return response.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

export const isFanVideoApiSuccess = (res) =>
  String(res?.statusCode || '') === '10000' || res?.statusCode == null;

export const getFanVideoApiPayload = (res) => res?.data ?? null;

/** GET /admin/fan-videos */
export const getAdminFanVideos = () => authFetch('/admin/fan-videos', { method: 'GET' });

/** GET /admin/fan-videos/fan-stories */
export const getGeneratedFanStories = ({ limit = 50, offset = 0, userId } = {}) => {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
  if (userId) params.set('userId', String(userId));
  return authFetch(`/admin/fan-videos/fan-stories?${params.toString()}`, { method: 'GET' });
};

/** POST /admin/fan-videos */
export const createAdminFanVideo = (body) =>
  authFetch('/admin/fan-videos', { method: 'POST', body: JSON.stringify(body) });

/** POST /admin/fan-videos with multipart video/thumbnail */
export const createAdminFanVideoMultipart = (formData) =>
  authMultipartFetch('/admin/fan-videos', formData, { method: 'POST' });

/** PUT /admin/fan-videos/:id */
export const updateAdminFanVideo = (id, body) =>
  authFetch(`/admin/fan-videos/${id}`, { method: 'PUT', body: JSON.stringify(body) });

/** PUT /admin/fan-videos/:id with multipart video/thumbnail */
export const updateAdminFanVideoMultipart = (id, formData) =>
  authMultipartFetch(`/admin/fan-videos/${id}`, formData, { method: 'PUT' });

/** POST /admin/fan-videos/upload */
export const uploadAdminFanVideoAssets = ({ videoFile, thumbnailFile } = {}) => {
  const formData = new FormData();
  if (videoFile) formData.append('video', videoFile);
  if (thumbnailFile) formData.append('thumbnail', thumbnailFile);
  return authMultipartFetch('/admin/fan-videos/upload', formData, { method: 'POST' });
};

/** PATCH /admin/fan-videos/:id/enabled */
export const setAdminFanVideoEnabled = (id, enabled) =>
  authFetch(`/admin/fan-videos/${id}/enabled`, {
    method: 'PATCH',
    body: JSON.stringify({ enabled }),
  });

/** DELETE /admin/fan-videos/:id */
export const deleteAdminFanVideo = (id) =>
  authFetch(`/admin/fan-videos/${id}`, { method: 'DELETE' });

/** GET /fan-story or /fan-story/:userId */
export const getFanStoryFeed = (userId) => {
  const suffix = userId ? `/${encodeURIComponent(userId)}` : '';
  return authFetch(`/fan-story${suffix}`, { method: 'GET' });
};
